exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-card-padding.card .card-block {\n  padding: 0;\n}\n.button-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.left-button {\n  display: flex;\n  justify-content: flex-start;\n}\n.center-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n.right-button {\n  display: flex;\n  justify-content: flex-end;\n}\n", ""]);

// exports
